import { getPublicCommerceItems } from "../../../utils/commerceRegistration";

export const CommerceRegistrationOptions = ({
  eventData,
  setEventData,
  formGroupCls,
}) => {
  if (!getPublicCommerceItems(eventData).length) return null;

  return (
    <>
      {eventData?.allowWaitlist && (
        <div className={formGroupCls}>
          <label className="checkbox-container">
            Force waitlist when all commerce items are unavailable
            <input
              type="checkbox"
              id="waitlistWhenCommerceUnavailable"
              name="waitlistWhenCommerceUnavailable"
              checked={eventData?.waitlistWhenCommerceUnavailable || false}
              aria-describedby="commerce-waitlist-help"
              onChange={(e) => setEventData({
                ...eventData,
                waitlistWhenCommerceUnavailable: e.target.checked,
              })}
            />
            <span className="checkmark"></span>
          </label>
          <p id="commerce-waitlist-help" className="text-sm mt-2">
            Automatically use the waitlist when no public commerce item can be selected.
          </p>
        </div>
      )}
      <div className={formGroupCls}>
        <label className="checkbox-container">
          Require at least one commerce item to complete registration
          <input
            type="checkbox"
            id="requireCommerceItem"
            name="requireCommerceItem"
            checked={eventData?.requireCommerceItem || false}
            aria-describedby="commerce-required-help"
            onChange={(e) => setEventData({
              ...eventData,
              requireCommerceItem: e.target.checked,
            })}
          />
          <span className="checkmark"></span>
        </label>
        <p id="commerce-required-help" className="text-sm mt-2">
          Attendees must select a quantity of at least one for a public commerce item.
          Waitlist registrations are exempt.
        </p>
      </div>
    </>
  );
};
